// @ts-nocheck
import "./style.css";
import Map from "ol/Map";
import View from "ol/View";
import { Control, defaults as defaultControls } from "ol/control";
import FullScreen from 'ol/control/FullScreen';
import { Zoom } from "ol/control";
import { getCenter } from "ol/extent";
import {
  Image as ImageLayer,
  Vector as VectorLayer,
  MapboxVector,
  Tile as TileLayer,
} from "ol/layer";
import VectorSource from "ol/source/Vector";
import { Cluster } from "ol/source";
import Projection from "ol/proj/Projection";
import { fromLonLat, transformExtent } from "ol/proj";
import XYZ from "ol/source/XYZ";

import Static from "ol/source/ImageStatic";
import { BeaconFeature } from "./features/beacon";
import { TrackedObjectFeature } from "./features/trackedObjects";
import { TrackLine } from "./features/trackLine";
import { ZoneFeature } from "./features/zone";
import { CommonFeature } from "./features/common";
import Overlay from "ol/Overlay";

import { clusterizedStyle } from "./styles/styles";
import { Feature } from "ol";
import geoImage from "./helpers/geoImage";
import { getRandomColor } from "./helpers/helpers";
import { map } from "lodash";
import { translate } from "ol/transform";

const { geoImageSource, geoImageLayer } = geoImage;
import {defaults as defaultInteractions } from 'ol/interaction';

const checkIsIos = () => {
  return  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export default class OpenLayersMap {
  constructor({
    target,
    imageURL,
    imageWidth,
    imageHeight,
    imageBounds,
    lat,
    lon,
    hor,
    w,
    h,
    isGlobalMap,
    token,
    styleUrl,
    translate,
    isAnimate
  }) {
    if (!imageWidth || !imageHeight || !imageURL) {
      throw new Error("not enought arguments to create map");
    }
    this.mapProps = {
      lat,
      lon,
      hor,
      w,
      h,
      imageBounds,
      target,
      imageURL,
      pixelSizes: {
        width: imageWidth,
        height: imageHeight,
      },
    };
    this.styleUrl = styleUrl;
    this.token = token;
    this.imageWidthInPixels = imageWidth;
    this.imageHeightInPixels = imageHeight;
    this.sources = {};
    this.sourcesClusterized = {};
    this.layers = {};
    this.stateBtn = false;
    this.stateGlobalMap = false;
    this.borderBtn = 0;
    this.translate = translate;
    this.isAnimate = isAnimate;

    if (isGlobalMap) {
      this.initGlobalMap(token, styles);
    } else {
      this.initImageMap();
    }

    this.modes = {
      drawTracks: false,
      globalMap: isGlobalMap,
    };

    this.zoneTypes = {};
    this._triggers = {};

    this.enum = {
      beacons: "beacons",
      venues: "venues",
      zones: "zones",
      locators: "locators",
      routes: "routes",
      barriers: "barriers",
      trackedObjects: "trackedObjects",
      trackLines: "trackLines",
    };
    this.layersZindex = {
      beacons: 10,
      venues: 10,
      zones: 3,
      locators: 10,
      routes: 9,
      barriers: 3,
      trackedObjects: 11,
      trackLines: 10,
    };
  }

  createChangeMapControl() {
    const button = document.createElement("button");
    !this.token  ? button.style.display = 'none': button.style.display = 'block';
    const element = document.createElement("div");
    const container = document.createElement("div");
    const btnTypeOne = document.createElement("button");
    const btnTypeTwo = document.createElement("button");
    const btnTypeThree = document.createElement("button");
    const btnTypeFour = document.createElement("button");
    const btnTypeFive = document.createElement("button");
    const btnTypeSix = document.createElement("button");
    btnTypeOne.innerHTML = `<span class='descriptionBtn'>${this.translate.global ? this.translate.global : 'Global'}</span>`;
    btnTypeTwo.innerHTML = `<span class='descriptionBtn'>${this.translate.local ? this.translate.local : 'Local'}</span>`;
    btnTypeThree.innerHTML = `<span class='descriptionBtn'>${this.translate.street ? this.translate.street : 'Street'}</span>`;
    btnTypeFour.innerHTML = `<span class='descriptionBtn'>${this.translate.satellite ? this.translate.satellite : 'Satellite'}</span>`;
    btnTypeFive.innerHTML = `<span class='descriptionBtn'>${this.translate.noImg ? this.translate.img : 'noImg'}</span>`;
    btnTypeSix.innerHTML = `<span class='descriptionBtn'>${this.translate.img ? this.translate.noImg : 'noImg'}</span>`;
    button.classList.add("switcher");
    container.classList.add("wrapper");
    this.stateBtn === true
      ? (container.style.display = "grid")
      : (container.style.display = "none");
    btnTypeTwo.classList.add("btn", "localMap", "switcherSelected");
    btnTypeOne.classList.add("btn", "globalMap");
    btnTypeFour.classList.add("btn", "satelliteMap");
    btnTypeFive.classList.add("btn", "withObj");
    btnTypeSix.classList.add("btn", "withoutObj");
    this.stateGlobalMap === true
      ? (btnTypeThree.disabled = false)
      : (btnTypeThree.disabled = true);
    this.stateGlobalMap === true
      ? btnTypeThree.classList.add("btn", "simpleMap")
      : btnTypeThree.classList.add("btn", "simpleMapDisable");
    this.stateGlobalMap === true
      ? (btnTypeFour.disabled = false)
      : (btnTypeFour.disabled = true);
    this.stateGlobalMap === true
      ? btnTypeFour.classList.add("btn", "simpleMap")
      : btnTypeFour.classList.add("btn", "simpleMapDisable");
    this.stateGlobalMap === true
      ? (btnTypeFive.disabled = false)
      : (btnTypeFive.disabled = true);
    this.stateGlobalMap === true
      ? btnTypeFive.classList.add("btn", "simpleMap")
      : btnTypeFive.classList.add("btn", "simpleMapDisable");
    this.stateGlobalMap === true
      ? (btnTypeSix.disabled = false)
      : (btnTypeSix.disabled = true);
    this.stateGlobalMap === true
      ? btnTypeSix.classList.add("btn", "simpleMap")
      : btnTypeSix.classList.add("btn", "simpleMapDisable");
    container.appendChild(btnTypeOne);
    container.appendChild(btnTypeTwo);
    container.appendChild(btnTypeThree);
    container.appendChild(btnTypeFour);
    container.appendChild(btnTypeFive);
    container.appendChild(btnTypeSix);
    element.appendChild(button);
    element.appendChild(container);

    const clickCallBack = () => {
      if (!this.stateBtn) {
        this.stateBtn = true
        container.style.display = "grid";
      } else {
        container.style.display = "none";
        this.stateBtn = false
      }
    };
    
    const clickCallBackGlobalMap = () => {
      if (this.modes.globalMap) {
        return;
      }
      this.modes.globalMap = true;
      this.initGlobalMap(this.token, this.styleUrl);
      this.updateFeaturesCoords();
      btnTypeOne.classList.add("switcherSelected");
      btnTypeTwo.classList.remove("switcherSelected");
      btnTypeFive.classList.add("switcherSelected");
      btnTypeThree.classList.add("switcherSelected");
      btnTypeThree.classList.add("simpleMap");
      btnTypeThree.classList.remove("simpleMapDisable");
      btnTypeThree.disabled = false;
      btnTypeFour.classList.add("simpleMap");
      btnTypeFour.classList.remove("simpleMapDisable");
      btnTypeFour.disabled = false;
      btnTypeFive.classList.add("simpleMap");
      btnTypeFive.classList.remove("simpleMapDisable");
      btnTypeFive.disabled = false;
      btnTypeSix.classList.add("simpleMap");
      btnTypeSix.classList.remove("simpleMapDisable");
      btnTypeSix.disabled = false;
    };
    const clickCallBackImgMap = () => {
      if (!this.modes.globalMap) {
        return;
      }
      this.stateGlobalMap = false;
      this.modes.globalMap = false;
      this.initImageMap();
      this.updateFeaturesCoords();
      btnTypeTwo.classList.add("switcherSelected");
      btnTypeOne.classList.remove("switcherSelected");
      btnTypeThree.classList.remove("switcherSelected");
      btnTypeFour.classList.remove("switcherSelected");
      btnTypeFive.classList.remove("switcherSelected");
      btnTypeSix.classList.remove("switcherSelected");
      btnTypeThree.classList.add("simpleMapDisable");
      btnTypeThree.classList.remove("simpleMap");
      btnTypeThree.disabled = true;
      btnTypeFour.classList.add("simpleMapDisable");
      btnTypeFour.classList.remove("simpleMap");
      btnTypeFour.disabled = true;
      btnTypeFive.classList.add("simpleMapDisable");
      btnTypeFive.classList.remove("simpleMap");
      btnTypeFive.disabled = true;
      btnTypeSix.classList.add("simpleMapDisable");
      btnTypeSix.classList.remove("simpleMap");
      btnTypeSix.disabled = true;
    };
    const clickCallBackVariant = () => {
      if (btnTypeThree.classList.contains("switcherSelected")) {
        return;
      }
      this.initVectorMap();
      btnTypeThree.classList.add("switcherSelected");
      btnTypeFour.classList.remove("switcherSelected");
    };
    const clickCallBackSatellite = () => {
      if (btnTypeFour.classList.contains("switcherSelected")) {
        return;
      }
      this.initSatelliteMap(this.token);
      btnTypeFour.classList.add("switcherSelected");
      btnTypeThree.classList.remove("switcherSelected");
    };
    const clickCallBackViewOn = () => {
      if (btnTypeFive.classList.contains("switcherSelected")) {
          return;
        }
        this.initViewOn();
        btnTypeFive.classList.add("switcherSelected");
        btnTypeSix.classList.remove("switcherSelected");
      };
      const clickCallBackViewOff = () => {
        if (btnTypeSix.classList.contains("switcherSelected")) {
          return;
        }
        this.initViewOff();
        btnTypeFive.classList.remove("switcherSelected");
        btnTypeSix.classList.add("switcherSelected");
      };
    const control = new Control({ element });
    button.addEventListener("click", clickCallBack.bind(this));
    btnTypeOne.addEventListener("click", clickCallBackGlobalMap);
    btnTypeTwo.addEventListener("click", clickCallBackImgMap);
    btnTypeThree.addEventListener("click", clickCallBackVariant);
    btnTypeFour.addEventListener("click", clickCallBackSatellite);
    btnTypeFive.addEventListener("click", clickCallBackViewOn);
    btnTypeSix.addEventListener("click", clickCallBackViewOff);

    return control;
  }
  createGeoImgLayer() {
    const { lat, lon, hor, w, h, imageURL } = this.mapProps;

    return new geoImageLayer({
      opacity: 1,
      layerType: "geoImgTile",
      zIndex: 2,
      source: new geoImageSource({
        url: imageURL,
        center: fromLonLat([lon, lat]),
        lon: lon,
        lat: lat,
        imageWidth: w,
        imageHeight: h,
        projection: "EPSG:3857",
        imageRotate: (hor / 180) * Math.PI,
      }),
    });
  }

  initImageMap() {
    try {
      const { target, imageURL } = this.mapProps;
      if (!this.map || !(this.map instanceof Map)) {
        let interactions = defaultInteractions({pinchRotate: false, altShiftDragRotate: false});

        if(checkIsIos()){
          // bug on IOS with iteractions - page will die after rotating
         interactions = defaultInteractions({pinchRotate: false, altShiftDragRotate: false});
        } else {
          interactions = defaultInteractions();
        };

        this.map = new Map({
          interactions,
          controls: [new Zoom(), new FullScreen(), this.createChangeMapControl()],
          target,
        });

        this.map.on("singleclick", this.mapClickOnFeatureEvent.bind(this));
        this.map.set("linkToThis", this);
      }

      const layersToDel = [];

      this.map.getLayers().forEach((layer) => {
        if (layer && layer.get("layerType")) {
          layersToDel.push(layer);
        }
      });

      layersToDel.forEach((layer) => {
        this.map.removeLayer(layer);
      });

      const extent = [0, 0, this.imageWidthInPixels, this.imageHeightInPixels];
      this.extentMap = extent;
      this.defaultCenter = getCenter(extent);
      this.defaultExtent = extent;

      const projection = new Projection({
        units: "pixels",
        extent,
      });
      this.projectionMap = projection;

      const layer = new ImageLayer({
        source: new Static({
          url: imageURL,
          projection,
          imageExtent: extent,
          crossOrigin: "Anonymous",
        }),
      });

      this.mainLayer = layer;

      this.map.setView(
        new View({
          projection,
          center: this.defaultCenter,
          zoom: 2,
          maxZoom: 8,
        })
      );

      this.map.addLayer(this.mainLayer);
    } catch (e) {
      console.log(e);
    }
  }

  initGlobalMap(token, styles) {
    const {
      lat,
      lon,
      hor,
      w,
      h,
      imageBounds,
      target,
      imageURL,
    } = this.mapProps;

    const boundsArray = imageBounds.split(";").map((val) => parseFloat(val));
    const extent = transformExtent(
      [boundsArray[3], boundsArray[2], boundsArray[1], boundsArray[0]],
      "EPSG:4326",
      "EPSG:3857"
    );

    this.extentMap = extent;
    this.defaultCenter = getCenter(extent);
    this.defaultExtent = extent;

    const view = new View({
      center: fromLonLat([lon, lat]),
      zoom: 20,
      maxZoom: 25,
      minZoom: 1,
    });

    const layersToDel = [];

    this.map.getLayers().forEach((layer) => {
      if (layer instanceof ImageLayer) {
        layersToDel.push(layer);
      }
    });

    layersToDel.forEach((layer) => {
      this.map.removeLayer(layer);
    });

    //

    this.initViewOn();

    this.initVectorMap();

    this.map.setView(view);
    view.fit(extent);
  }

  initSatelliteMap() {
    const layersToDel = [];

    this.map.getLayers().forEach((layer) => {
      if (layer instanceof MapboxVector) {
        layersToDel.push(layer);
      }
    });

    layersToDel.forEach((layer) => {
      this.map.removeLayer(layer);
    });

    const streetUrl = `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/256/{z}/{x}/{y}?access_token=${this.token}`;
    const streetsMap = new TileLayer({
      source: new XYZ({
        url: streetUrl,
      }),
      zIndex: 1,
    });
    streetsMap.set("layerType", "tiles");
    this.map.addLayer(streetsMap);
    this.mainLayer = streetsMap;
    this.map.getLayers().forEach((i) => {});
  }
  initVectorMap() {
    if (!this.token || !this.styleUrl) {
      console.error("No mapbox token or mapbox style url");

      return;
    }
    const layersToDel = [];

    this.map.getLayers().forEach((layer) => {
      if (layer instanceof TileLayer) {
        layersToDel.push(layer);
      }
    });

    layersToDel.forEach((layer) => {
      this.map.removeLayer(layer);
    });

    const vectorMap = new MapboxVector({
      styleUrl: this.styleUrl,
      accessToken: this.token,
      zIndex: 1,
    });
    vectorMap.set("layerType", "tiles");

    this.map.addLayer(vectorMap);
    this.mainLayer = vectorMap;
  }

  initViewOff() {
    this.map.getLayers().forEach((layer) => {
      if (layer instanceof ImageLayer) {
        this.map.removeLayer(layer);
      }
    });
  }
  initViewOn() {
    this.map.addLayer(this.createGeoImgLayer());
  }

  updateFeaturesCoords() {
    const trackedObjectType = this.enum.trackedObjects;
    if (this.sources[trackedObjectType]) {
      this.sources[trackedObjectType].forEachFeature((feature) => {
        const trackedObjectClass = this.getFeaturePayload(feature);
        trackedObjectClass.trackLine = undefined;
      });
      this.deleteAllFeaturesFromSourse(this.enum.trackLines);
    }

    Object.values(this.sources).forEach((source) => {
      source.getFeatures().forEach((olFeature) => {
        const feature = this.getFeaturePayload(olFeature);
        feature.updateCoord();
      });
    });
  }

  // common map iterations

  on(event, callback) {
    if (!this._triggers[event]) {
      this._triggers[event] = [];
    }
    this._triggers[event].push(callback);
  }

  off(event) {
    this._triggers[event] = [];
  }

  triggerHandler(event, data) {
    if (this._triggers[event]) {
      for (let i in this._triggers[event]) this._triggers[event][i](data);
    }
  }

  destroyMap() {
    this.map.setTarget(undefined);
  }

  addModal(
    htmlElement,
    options = {
      autoPan: true,
      stopEvent: false,
      positioning: "bottom-center",
      animationDuration: 250,
    }
  ) {
    const overlay = new Overlay({
      element: htmlElement,
      autoPan: options.autoPan,
      stopEvent: options.stopEvent,
      positioning: options.positioning,
      autoPanAnimation: {
        duration: options.animationDuration,
      },
    });
    this.map.addOverlay(overlay);

    return overlay;
  }

  // sources and layers iterations

  addSourceAndLayerIfNeeded(type) {
    // if there's no source in sources object (by provided type)
    // we will add one
    if (!this.sources[type]) {
      this.sources[type] = new VectorSource({
        type,
      });
      // if there already was layer with this type
      // but there wasn't source - we will set source to this layer
      if (this.layers[type]) {
        this.layers[type].setSource(this.sources[type]);
      }
    }
    // if there no layer with this type,
    // we will add one and provide source with corresponding type

    if (!this.layers[type]) {
      this.layers[type] = new VectorLayer({
        type,
        source: this.sources[type],
      });
      this.map.addLayer(this.layers[type]);
      this.layers[type].setZIndex(this.layersZindex[type]);
    }
  }

  // common features iterations

  zoomToFeature(feature, padding = 150 , duration = 600, maxZoom = 5) {
    if (!feature || !this.map) {
      return;
    }
    const view = this.map.getView();

    view.fit(feature.getGeometry(), {
      duration: duration,
      padding: [padding, padding, padding, padding],
      maxZoom
    });
  }

  getFeatureByIdAndType(id, type) {
    if (!this.sources[type]) {
      return;
    }
    return this.sources[type].getFeatureById(id);
  }

  changeFeatureCoordinates(feature, coordinates) {
    return feature.getGeometry().setCoordinates(coordinates);
  }

  mapClickOnFeatureEvent(evt) {
    if(this.stateBtn){
      document.querySelector('.wrapper').style.display = 'none';
      this.stateBtn = false;
    }
    const featuresArray = this.map.getFeaturesAtPixel(evt.pixel);
    let array = [];
    if (featuresArray[0] && featuresArray[0] instanceof Feature) {
      if (featuresArray[0].get("payload")) {
        array = featuresArray.map((featureElement) =>
          featureElement.get("payload")
        );
      } else {
        const childFeatureArray = featuresArray[0].get("features");
        if(childFeatureArray){
          array = childFeatureArray.map((featureParent) =>
            featureParent.get("payload")
          );
        }
      }
    }
    this.triggerHandler("mapClicked", {
      featuresArray: array,
      feature: array[0],
      coordinates: evt.coordinate,
    });
  }

  findFeatureOnMap(e) {
    const pixel = e.pixel || this.map.getEventPixel(e.originalEvent);
    const oFeature = [];
    this.map.forEachFeatureAtPixel(pixel, (feature) => {
      if (feature.get("type")) {
        oFeature.push(feature);
      }
      return null;
    });
    return oFeature;
  }

  getFeaturePayload(feature) {
    if (!feature) {
      return;
    }
    return feature.get("payload");
  }

  deleteFeatureFromSourse(feature, type) {
    if (!feature || !(feature instanceof Feature) || !type) {
      return;
    }
    const source = this.sources[type];
    if (!source) {
      return;
    }
    this.sources[type].removeFeature(feature);
  }

  deleteAllFeaturesFromSourse(type) {
    if (this.sources[type]) {
      this.sources[type].clear();
    }
  }

  addClusterizedFeatures(distance, type) {
    const source = this.sources[type];

    const clusterSource = new Cluster({
      distance: parseInt(distance, 10),
      source: source,
    });

    if (!this.sourcesClusterized[type]) {
      this.sourcesClusterized[type] = clusterSource;
    }

    const clustersLayer = new VectorLayer({
      source: clusterSource,
      style: function (feature) {
        const size = feature.get("features").length;
        let style; // = styleCache[size];
        if (size > 1) {
          style = clusterizedStyle(size);
        } else {
          style = feature.get("features")[0].getStyle();
        }

        return style;
      },
    });
    if (this.layers[type]) {
      this.map.removeLayer(this.layers[type]);
    }
    this.map.addLayer(clustersLayer);
    this.layers[type] = clustersLayer;
    this.layers[type].setZIndex(this.layersZindex[type]);
  }

  removeClusterizedFeatures(type) {
    if (this.layers[type]) {
      this.map.removeLayer(this.layers[type]);
    }

    if (this.sourcesClusterized[type]) {
      delete this.sourcesClusterized[type];
    }

    this.addSourceAndLayerIfNeeded(type);
    this.map.addLayer(this.layers[type]);
    this.layers[type].setSource(this.sources[type]);
  }

  addCustomFeature({ type, geometryType, payload, coordinates, styles }) {
    this.addSourceAndLayerIfNeeded(type);

    const feature = new CommonFeature({
      imgPxWidth: this.imageWidthInPixels,
      imgPxHeight: this.imageHeightInPixels,
      coordinates,
      type,
      geometryType,
      styles,
      payload,
    });
    // create feature
    this.sources[type].addFeature(feature);
    return feature;
  }

  // zones iterations

  getZoneFeature(id) {
    return this.getFeatureByIdAndType(id, this.enum.zones);
  }

  addZones(zones) {
    zones.forEach((zone) => {
      this.addZone(zone);
    });
  }

  setZoneTypes(zoneTypes) {
    let zoneTypeObject = {};
    if (Array.isArray(zoneTypes)) {
      zoneTypes.map((type) => {
        zoneTypeObject[type.id] = type;

        return type;
      });
    } else {
      zoneTypeObject = zoneTypes;
    }
    this.zoneTypes = Object.assign({}, zoneTypeObject);
  }

  addZone(zone) {
    if (!this.zoneTypes || !zone) {
      return;
    }
    const type = this.enum.zones;
    this.addSourceAndLayerIfNeeded(type);
    const zoneTypeID = zone.zoneTypeID || zone.zone_type || zone.zoneType;
    const zoneType = this.zoneTypes[zoneTypeID];

    const featureZone = new ZoneFeature(
      this.imageWidthInPixels,
      this.imageHeightInPixels,
      zone,
      type,
      zoneType,
      this,
      this.mapProps
    );
    if (!featureZone) {
      return;
    }

    this.sources[type].addFeature(featureZone);
  }

  // beacons iterations

  addBeacons(beacons, style, batteryColors) {
    const type = this.enum.beacons;
    this.addSourceAndLayerIfNeeded(type);

    beacons.map((beacon) => {
      const featureBeacon = new BeaconFeature(
        this,
        this.imageWidthInPixels,
        this.imageHeightInPixels,
        beacon,
        type,
        style,
        batteryColors
      );
      if (!featureBeacon) {
        return;
      }
      this.sources[type].addFeature(featureBeacon);
    });
  }

  // track history iterations

  addTrackHistory() {
    this.modes.drawTracks = true;
  }

  removeTrackHistory() {
    this.modes.drawTracks = false;
    const trackedObjectType = this.enum.trackedObjects;

    if (!this.sources[trackedObjectType]) {
      return;
    }
    this.sources[trackedObjectType].forEachFeature((feature) => {
      const trackedObjectClass = this.getFeaturePayload(feature);
      trackedObjectClass.trackLine = undefined;
    });
    this.deleteAllFeaturesFromSourse(this.enum.trackLines);
  }

  removeTrackLine(feature) {
    this.deleteFeatureFromSourse(feature, this.enum.trackLines);
  }

  addTrackLineOnSource(trackObjectId, coordinates, color) {
    const trackLineType = this.enum.trackLines;
    this.addSourceAndLayerIfNeeded(trackLineType);
    const featureTrackLine = new TrackLine({
      imageWidthInPixels: this.imageWidthInPixels,
      imageHeightInPixels: this.imageHeightInPixels,
      trackObjectId,
      coordinates,
      type: trackLineType,
      color: color || getRandomColor(),
    });

    this.sources[trackLineType].addFeature(featureTrackLine);

    return featureTrackLine;
  }

  // tracked objects iterations

  removeAllTrackedObjects() {
    const type = this.enum.trackedObjects;
    this.sources[type].getFeatures().forEach((feature) => {
      const trackedObjectClass = this.getFeaturePayload(feature);
      if (trackedObjectClass.trackLine) {
        this.removeTrackLine(trackedObjectClass.trackLine);
      }
      this.deleteFeatureFromSourse(feature, this.enum.trackedObjects);
    });
  }

  getTrackedObjectFeature(id) {
    return this.getFeatureByIdAndType(id, this.enum.trackedObjects);
  }

  getAllTrackedObjects() {
    const trackedObjectType = this.enum.trackedObjects;

    if (this.sources[trackedObjectType]) {
      return this.sources[trackedObjectType].getFeatures();
    }

    return [];
  }

  deleteTrackedObject(feature) {
    const trackedObjectClass = this.getFeaturePayload(feature);
    if (trackedObjectClass.trackLine) {
      this.removeTrackLine(trackedObjectClass.trackLine);
    }
    this.deleteFeatureFromSourse(feature, this.enum.trackedObjects);
  }

  async highlightTrackedObject(trackedObjectSource, color) {
    const trackedObjectFeature = this.sources[
      this.enum.trackedObjects
    ].getFeatureById(parseInt(trackedObjectSource.id));
    const trackedObject = this.getFeaturePayload(trackedObjectFeature);
    await trackedObject.setSelectObejctStyle(color, trackedObjectFeature);
  }

  async unHighlightTrackedObject(trackedObjectSource) {
    if (!trackedObjectSource || !this.sources[this.enum.trackedObjects]) {
      return;
    }
    const trackedObjectFeature = this.sources[
      this.enum.trackedObjects
    ].getFeatureById(parseInt(trackedObjectSource.id));
    const trackedObject = this.getFeaturePayload(trackedObjectFeature);
    if (trackedObject) {
      await trackedObject.resetStyles();
    }
  }

  zoomToTrackedObjectByID(id) {
    const trackedObjectFeature = this.sources[
      this.enum.trackedObjects
    ].getFeatureById(parseInt(id));
    this.zoomToFeature(trackedObjectFeature, null);
  }

  async addTrackedObject(object, style) {
    if (!object) {
      return;
    }
    const type = this.enum.trackedObjects;

    this.addSourceAndLayerIfNeeded(type);

    const featureObject = await new TrackedObjectFeature(
      this,
      this.imageWidthInPixels,
      this.imageHeightInPixels,
      object,
      type,
      style,
      {
        mapProps: this.mapProps,
        extent: this.extentMap,
      }
    );
    if (!featureObject) {
      return;
    }
    this.sources[type].addFeature(featureObject);
  }

  addTrackedObjects(objects, style) {
    const type = this.enum.trackedObjects;
    this.deleteAllFeaturesFromSourse(type);

    objects.map(async (object) => {
      await this.addTrackedObject(object, style).catch((err) =>
        console.log(err)
      );
    });
  }
}
